import styled from 'styled-components';
import { Link } from 'studio5/components';

export const FlexHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
  align-items: center;
`;

export const FlexFooterContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const StyledFigure = styled.figure`
  height: 56px;
  width: 56px;
`;

export const StyledImg = styled.img`
  width: 100%;
`;

export const StyledLink = styled(Link)`
  width: 100%;
  align-items: center;
  justify-content: center;
`;
